/**图片回复的字段 */
import { BaseModel } from '../BaseModel';

export  class WxGroup extends BaseModel{ 
    GatherId:number=0 
    Title:string=""
    MsgType:number=99
    SendType:any=1
    Sex:number=-1
    Provide:any=[]
    City:any=[]
    Area:any=[]
    SetSendDate:string=""
    IsSetSendDate:number=1
    txtImportFans:any
    Status:number=1
    SendStatus:any=0;
    peopleList:any=[];
}